import { request } from '@/service/http'

interface AuthenticationData {
  mobile: number | string
  mobileVerificationCode: number | string
}

interface PwdData {
  userpass1: string
  userpass2: string
}

interface EmailData {
  email: string
  emailVerificationCode: string
}

/**
 *  身份校验手机号
 */
export function authenticationByMobile(data: AuthenticationData) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/authenticationByMobile', data)
  return methodInstance
}

/**
 *  查询是否做了权限校验 token
 */
export function checkAuthenticationed() {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/user/membercenter/checkAuthenticationed')
  return methodInstance
}

/**
 *  重置密码
 */
export function changePassword(data: PwdData) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/changePassword', data)
  return methodInstance
}

/**
 *  发送邮箱验证码
 */
export function sendEmailVerificationCode(data: any) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/sendEmailVerificationCode', data)
  return methodInstance
}

/**
 *  更换邮箱
 */
export function changeEmail(data: EmailData) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/changeEmail', data)
  return methodInstance
}

/**
 *  更换手机号
 */
export function changeMobile(data: AuthenticationData) {
  const methodInstance = request.Post<Service.ResponseResult<any>>('/user/membercenter/changeMobile', data)
  return methodInstance
}

/**
 *  重置密钥对
 */
export function getKeyPair(params: { username: string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/api-log/log/getKeyPair', { params })
  return methodInstance
}

/*
* 获取密钥对
 */
export function queryKeyPairByUsername(params: { username: string }) {
  const methodInstance = request.Get<Service.ResponseResult<any>>('/api-log/log/queryKeyPairByUsername', { params })
  return methodInstance
}

/**
 *  设置 是否开启登录二次验证-1开启,0关闭
 */
export function setloginSecondVerificationStatus(data: any) {
  const methodInstance = request.Put<Service.ResponseResult<any>>(`/user/membercenter/setloginSecondVerificationStatus?loginSecondVerificationStatus=${data}`)
  return methodInstance
}
